const Images = {
  fodrixiconnew: require("./fodrixiconnew.webp").default,
  paymentOpt: require("./payment-opt.png").default,
  payment_QR_code: require("./payment_QR-code.jpg").default,

  stickMan: require("./img_stickman_animation.webp").default,

  backgroundlogin: require("./backgroundlogin.webp").default,

  community: require("./community.webp").default,

  roopkund: require("./ImageToCompress/roopkund.jpg").default,

  ahmedabad: require("./explore destination/ahmedabad.webp")
    .default,
  banglore: require("./explore destination/banglore.webp").default,
  chennai: require("./explore destination/chennai.webp").default,
  Mumbai: require("./explore destination/Mumbai.webp").default,
  pune: require("./explore destination/pune.webp").default,
  kolkata: require("./explore destination/kolkata.webp").default,
  Register: require("./Register.webp").default,

  home_img: require("./home_img.webp").default,

  new_1: require("./portfolio_img_new/1.webp").default,
  new_2: require("./portfolio_img_new/2.webp").default,
  new_3: require("./portfolio_img_new/3.webp").default,
  new_4: require("./portfolio_img_new/4.webp").default,
  new_5: require("./portfolio_img_new/5.webp").default,
  new_6: require("./portfolio_img_new/6.webp").default,
  new_7: require("./portfolio_img_new/7.webp").default,
  new_8: require("./portfolio_img_new/8.webp").default,
  new_9: require("./portfolio_img_new/9.webp").default,
  new_10: require("./portfolio_img_new/10.webp").default,

  babyshoot_1: require("./portfolio/babyshoot/1.webp").default,
  babyshoot_2: require("./portfolio/babyshoot/2.webp").default,
  babyshoot_3: require("./portfolio/babyshoot/3.webp").default,
  babyshoot_4: require("./portfolio/babyshoot/4.webp").default,
  babyshoot_5: require("./portfolio/babyshoot/5.webp").default,
  babyshoot_6: require("./portfolio/babyshoot/6.webp").default,
  babyshoot_7: require("./portfolio/babyshoot/7.webp").default,
  babyshoot_8: require("./portfolio/babyshoot/8.webp").default,
  babyshoot_9: require("./portfolio/babyshoot/9.webp").default,
  babyshoot_10: require("./portfolio/babyshoot/10.webp").default,
  babyshoot_11: require("./portfolio/babyshoot/11.webp").default,
  babyshoot_12: require("./portfolio/babyshoot/12.webp").default,
  babyshoot_13: require("./portfolio/babyshoot/13.webp").default,
  babyshoot_14: require("./portfolio/babyshoot/14.webp").default,
  babyshoot_15: require("./portfolio/babyshoot/15.webp").default,
  babyshoot_16: require("./portfolio/babyshoot/16.webp").default,
  babyshoot_17: require("./portfolio/babyshoot/17.webp").default,
  babyshoot_18: require("./portfolio/babyshoot/18.webp").default,
  babyshoot_19: require("./portfolio/babyshoot/19.webp").default,
  babyshoot_20: require("./portfolio/babyshoot/20.webp").default,

  personal_1: require("./portfolio/Personal Portrait/1.webp").default,
  personal_2: require("./portfolio/Personal Portrait/2.webp").default,
  personal_3: require("./portfolio/Personal Portrait/3.webp").default,
  personal_4: require("./portfolio/Personal Portrait/4.webp").default,
  personal_5: require("./portfolio/Personal Portrait/5.webp").default,
  personal_6: require("./portfolio/Personal Portrait/6.webp").default,
  personal_7: require("./portfolio/Personal Portrait/7.webp").default,
  personal_8: require("./portfolio/Personal Portrait/8.webp").default,
  personal_9: require("./portfolio/Personal Portrait/9.webp").default,
  personal_10: require("./portfolio/Personal Portrait/10.webp").default,
  personal_11: require("./portfolio/Personal Portrait/11.webp").default,
  personal_12: require("./portfolio/Personal Portrait/12.webp").default,
  personal_13: require("./portfolio/Personal Portrait/13.webp").default,
  personal_14: require("./portfolio/Personal Portrait/14.webp").default,
  personal_15: require("./portfolio/Personal Portrait/15.webp").default,
  personal_16: require("./portfolio/Personal Portrait/16.webp").default,
  personal_17: require("./portfolio/Personal Portrait/17.webp").default,
  personal_18: require("./portfolio/Personal Portrait/18.webp").default,
  personal_19: require("./portfolio/Personal Portrait/19.webp").default,
  personal_20: require("./portfolio/Personal Portrait/20.webp").default,
  personal_21: require("./portfolio/Personal Portrait/21.webp").default,
  personal_22: require("./portfolio/Personal Portrait/22.webp").default,
  personal_23: require("./portfolio/Personal Portrait/23.webp").default,
  personal_24: require("./portfolio/Personal Portrait/24.webp").default,
  personal_25: require("./portfolio/Personal Portrait/25.webp").default,
  personal_26: require("./portfolio/Personal Portrait/26.webp").default,
  personal_27: require("./portfolio/Personal Portrait/27.webp").default,
  personal_28: require("./portfolio/Personal Portrait/28.webp").default,
  personal_29: require("./portfolio/Personal Portrait/29.webp").default,
  personal_30: require("./portfolio/Personal Portrait/30.webp").default,
  personal_31: require("./portfolio/Personal Portrait/31.webp").default,
  personal_32: require("./portfolio/Personal Portrait/32.webp").default,

  prewedding_1: require("./portfolio/Pre-wedding/1.webp").default,
  prewedding_2: require("./portfolio/Pre-wedding/2.webp").default,
  prewedding_3: require("./portfolio/Pre-wedding/3.webp").default,
  prewedding_4: require("./portfolio/Pre-wedding/4.webp").default,
  prewedding_5: require("./portfolio/Pre-wedding/5.webp").default,
  prewedding_6: require("./portfolio/Pre-wedding/6.webp").default,
  prewedding_7: require("./portfolio/Pre-wedding/7.webp").default,
  prewedding_8: require("./portfolio/Pre-wedding/8.webp").default,
  prewedding_9: require("./portfolio/Pre-wedding/9.webp").default,
  prewedding_10: require("./portfolio/Pre-wedding/10.webp").default,
  prewedding_11: require("./portfolio/Pre-wedding/11.webp").default,
  prewedding_12: require("./portfolio/Pre-wedding/12.webp").default,
  prewedding_13: require("./portfolio/Pre-wedding/13.webp").default,
  prewedding_14: require("./portfolio/Pre-wedding/14.webp").default,
  prewedding_15: require("./portfolio/Pre-wedding/15.webp").default,
  prewedding_16: require("./portfolio/Pre-wedding/16.webp").default,
  prewedding_17: require("./portfolio/Pre-wedding/17.webp").default,
  prewedding_18: require("./portfolio/Pre-wedding/18.webp").default,
  prewedding_19: require("./portfolio/Pre-wedding/19.webp").default,
  prewedding_20: require("./portfolio/Pre-wedding/20.webp").default,
  prewedding_21: require("./portfolio/Pre-wedding/21.webp").default,
  prewedding_22: require("./portfolio/Pre-wedding/22.webp").default,
  prewedding_23: require("./portfolio/Pre-wedding/23.webp").default,
  prewedding_24: require("./portfolio/Pre-wedding/24.webp").default,
  prewedding_25: require("./portfolio/Pre-wedding/25.webp").default,
  prewedding_26: require("./portfolio/Pre-wedding/26.webp").default,
  prewedding_27: require("./portfolio/Pre-wedding/27.webp").default,
  prewedding_28: require("./portfolio/Pre-wedding/28.webp").default,
  prewedding_29: require("./portfolio/Pre-wedding/29.webp").default,
  prewedding_30: require("./portfolio/Pre-wedding/30.webp").default,

  business_1: require("./portfolio/Business/1.webp").default,
  business_2: require("./portfolio/Business/2.webp").default,
  business_3: require("./portfolio/Business/3.webp").default,
  business_4: require("./portfolio/Business/4.webp").default,

  wedding_1: require("./portfolio/Wedding/1.webp").default,
  wedding_2: require("./portfolio/Wedding/2.webp").default,
  wedding_3: require("./portfolio/Wedding/3.webp").default,
  wedding_4: require("./portfolio/Wedding/4.webp").default,
  wedding_5: require("./portfolio/Wedding/5.webp").default,
  wedding_6: require("./portfolio/Wedding/6.webp").default,
  wedding_7: require("./portfolio/Wedding/7.webp").default,
  wedding_8: require("./portfolio/Wedding/8.webp").default,

  other_1: require("./portfolio/Other/1.webp").default,
  other_2: require("./portfolio/Other/2.webp").default,
  other_3: require("./portfolio/Other/3.webp").default,
  other_4: require("./portfolio/Other/4.webp").default,
  other_5: require("./portfolio/Other/5.webp").default,
  other_6: require("./portfolio/Other/6.webp").default,
  other_7: require("./portfolio/Other/7.webp").default,
  other_8: require("./portfolio/Other/8.webp").default,

  family_1: require("./portfolio/Family shoot/1.webp").default,
  family_2: require("./portfolio/Family shoot/2.webp").default,
  family_3: require("./portfolio/Family shoot/3.webp").default,
  family_4: require("./portfolio/Family shoot/4.webp").default,
  family_5: require("./portfolio/Family shoot/5.webp").default,
  family_6: require("./portfolio/Family shoot/6.webp").default,
  family_7: require("./portfolio/Family shoot/7.webp").default,
  family_8: require("./portfolio/Family shoot/8.webp").default,
  family_9: require("./portfolio/Family shoot/9.webp").default,

  maternity_1: require("./portfolio/Maternity shoot/1.webp").default,
  maternity_2: require("./portfolio/Maternity shoot/2.webp").default,
  maternity_3: require("./portfolio/Maternity shoot/3.webp").default,
  maternity_4: require("./portfolio/Maternity shoot/4.webp").default,
  maternity_5: require("./portfolio/Maternity shoot/5.webp").default,

  travel: require("./photoshoot_home/TravelService.webp").default,
  business: require("./photoshoot_home/BusinessService.webp")
    .default,
  Wedding: require("./photoshoot_home/WeddingService.webp").default,
  prewedding: require("./photoshoot_home/Preweddingshoot.webp")
    .default,
  otherService: require("./photoshoot_home/Otherservice.webp")
    .default,
  PersonalPortrait:
    require("./ImageToCompress/Personalportrait.jpg").default,
  maternity: require("./photoshoot_home/Maternityshoot.webp")
    .default,
  baby: require("./ImageToCompress/Babyshoot.jpg").default,
  Family: require("./ImageToCompress/Familyshoot.jpg").default,
  Front1: require("./front1.webp").default,
  Howdoesitworks: require("./Howdoesitworks.webp").default,
  excitedtoshowcity: require("./pg40/pg40/excited-to-show-city.webp").default,
  photographyequip: require("./pg40/pg40/photography-equip.webp").default,
  professionalism: require("./pg40/pg40/professionalism.webp").default,
  stayupdated: require("./pg40/pg40/stay-updated.webp").default,
  Diversity: require("./pg39/pg39/diversify-portfolio.png").default,
  Earnextra: require("./pg39/pg39/earn-extra-money.png").default,
  JoinCommunity: require("./pg39/pg39/join-community.png").default,
  receivephotoshoot: require("./pg39/pg39/receive-shoot-request.png").default,
  Youshootweedit: require("./pg39/pg39/you-shoot-we-edit.png").default,
  BecomeFodrixographer: require("./BecomeFodrixographerLatest.webp").default,
  assignphotographer: require("./pg17/assign-a-photograapher.webp").default,
  career: require("./pg18-1-1.webp").default,
  bookashooticon: require("./pg17/book-a-shoot.webp").default,
  knowabout: require("./pg17/know-about.webp").default,
  shootday: require("./pg17/shoot-day.webp").default,
  receivephotoshowitworks: require("./pg17/receive-photos.webp").default,
  Bookyourshoot: require("./Bookyourshoot.png").default,
  meeturphotographer: require("./meeturphotographer.webp").default,
  receivephotos: require("./receiveurphotos.webp").default,
  Aboutusshow: require("./Aboutusshow.webp").default,
  aboutusgraphics: require("./aboutusgraphics1.webp").default,
  DASHBOARD1: require("./DASHBOARD1.webp").default,

  contactpage: require("./contactpage.webp").default,

  AnkitKesarwani: require("./aboutus/Ankit Kesarwani.webp").default,
  ShubhamWagh: require("./aboutus/ShubhamWagh.webp").default,
  Atharva: require("./aboutus/Atharva Joshi.jpg").default,
  Prateek: require("./aboutus/Prateek Vishwakarma.jpg").default,
  Deepshikha: require("./aboutus/Deepshikha.webp").default,
  Prashant: require("./aboutus/Prashant.webp").default,
  SramanMukherjeee: require("./aboutus/SramanMukherjeee.webp").default,
  Mohitagrawal: require("./aboutus/Mohit Agrawal.webp").default,
  Himanshukesharwani: require("./aboutus/Himanshu Kesarwani.webp").default,
  SandeepJha: require("./aboutus/sandeepJha.webp").default,

  harpreet: require("./testimonial1/Harpreet kaur.webp").default,
  jyoti: require("./testimonial1/jyoti-singh.webp").default,
  mehul: require("./testimonial1/mehul-rastogi.webp").default,
  ojaswi: require("./testimonial1/ojaswi.webp").default,
  rishabh: require("./testimonial1/rishabh.webp").default,
  zeeshan: require("./testimonial1/zeeshan.webp").default,
  imambara: require("./testimonial1/imambara.webp").default,

  manali1: require("./Blog 1/manali1.webp").default,
  manali2: require("./Blog 1/manali2.webp").default,
  manali3: require("./Blog 1/manali3.webp").default,
  manali4: require("./Blog 1/manali4.webp").default,
  manali5: require("./Blog 1/manali5.webp").default,
  manali6: require("./Blog 1/manali6.webp").default,
  // manali6: require("./Blog 1/manali6.webp").default,
  kerala: require("./Blog 1/kerala.webp").default,
  dubai: require("./Blog 1/dubai.webp").default,

  hamburger: require("./hamburgerIcon.webp").default,

  Bark: require("./PartnersLogo/WEBP/Bark.webp").default,
  Canvera: require("./PartnersLogo/WEBP/Canvera.webp").default,
  Sortlist: require("./PartnersLogo/WEBP/Sortlist.webp").default,
  SulekhaLogo: require("./PartnersLogo/WEBP/sulekha-logo.webp").default,
  Tripadvisor: require("./PartnersLogo/WEBP/Tripadvisor.webp").default,
  Trustpilot: require("./PartnersLogo/WEBP/Trustpilot.webp").default,
  WedMeGood: require("./PartnersLogo/WEBP/Wed me good.webp").default,
  WeddingWire: require("./PartnersLogo/WEBP/Wedding wire.webp").default,


  // new images for about page ....testing...

  Aboutus1: require("./PG19-1.png").default,
  Aboutus2: require("./PG19-2.png").default,
  Aboutus3: require("./pg18-2.png").default,
};

export default Images;
